import { render } from "./CalendarEventAttendees.vue?vue&type=template&id=721aaf48&scoped=true"
import script from "./CalendarEventAttendees.vue?vue&type=script&lang=ts"
export * from "./CalendarEventAttendees.vue?vue&type=script&lang=ts"

import "./CalendarEventAttendees.vue?vue&type=style&index=0&id=721aaf48&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-721aaf48"

export default script